// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousFriday as fn } from "../previousFriday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousFriday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default previousFriday;
